import { Component, Inject, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material';
import { CustomerService } from '../../../core/services/customer.service';
import { CreateContractService } from '../../../core/services/create-contract.service';
import { ProcedureService } from '../../../core/services/procedure.service';
import { EnterpriseService } from '../../../core/services/enterprise.service';
import { EnterpriseEntity } from '../../../core/class/enterpriseEntity';
import { ToastrService } from 'ngx-toastr';
import { UserEntity } from '../../../core/class/UserEntity';
import {EnumContractEnterpriseStatus, EnumContractStatus, EnumContractUserRole} from '../../../core/constants/contract';
import { CommonService } from '../../../core/services/common.service';
import { Message } from '../../../core/class/message';
import { FormControl } from '@angular/forms';
import { UserService } from '../../../core/services/user.service';
import { takeUntil } from 'rxjs/operators';
import { Subject } from 'rxjs';
import {SCREEN_SIZE} from "../../../core/constants/screen-size";
import * as uuid from 'uuid';
import {Common} from "../../../core/constants/common";

@Component({
  // tslint:disable-next-line:component-selector
  selector: 'add-customer-approve-dialog',
  templateUrl: './add-customer-approve-dialog.component.html',
  styleUrls: ['./add-customer-approve-dialog.component.scss']

})
export class AddCustomerApproveDialogComponent implements OnInit, OnDestroy {
  checkRequired = false;
  validateForm:any = false;
  dataSource:any;
  check :any = false;
  checkOrder:any = 1;
  phoneMaxLength = Common.MAX_LENGTH_PHONE;
  dataOld :any = [];
  phonePattern2 = Common.PHONE_PATTERN2;
  regxPhone = new RegExp(this.phonePattern2);
  constructor(
    public dialogRef: MatDialogRef<AddCustomerApproveDialogComponent>,
    private customerService: CustomerService,
    public createContractService: CreateContractService,
    private procedureService: ProcedureService,
    private enterpriseService: EnterpriseService,
    private toast: ToastrService,
    private userService: UserService,
    private commonService: CommonService,
    private message: Message,
    @Inject(MAT_DIALOG_DATA) public data: any,
  ) {
    dialogRef.disableClose = true;
    localStorage.setItem('dataPopupCreateDocument',JSON.stringify(this.data.data ? this.data.data :[]));
  }
  ngOnDestroy(): void {
    this.createContractService.procedureId = null;
  }

  ngOnInit() {
    // this.dataSource = this.data.data;
    const dataParent = JSON.parse(localStorage.getItem('dataPopupCreateDocument'));
    this.dataSource = dataParent;
    // if(this.dataSource.length > 0){
    //   this.dataSource.forEach(ele =>{
    //     if(ele.STT >= this.checkOrder){
    //       this.checkOrder = ele.STT + 1;
    //     }
    //   })
    // }
    if (this.dataSource.length == 0 || !this.dataSource.length){
      this.dataSource.push({
        'userId': uuid.v4(),
        'enterpriseId': uuid.v4(),
        'customerId': uuid.v4(),
        'STT':1,
        'name':'',
        'phoneNumber':'',
        'email':'',
        'taxCode':'',
        'CTS':false,
        'image':false,
        'checkMail':false,
        'checkTrung':false,
        'checkFocusSTT':false,
        'checkFocusName':false,
        'checkFocusMail':false,
        'checkFocusPhone':false,
        'checkFocusCertificate':false,
        'validateForm':false,
        'checkPhone':false,
        'checkCertificate':false,
      });
    }

  }
  addCustomer(){
    if(this.dataSource.length >0){
      this.checkOrder = 1;
      this.dataSource.forEach(ele =>{
        if(ele.STT >= this.checkOrder){
          ele.STT = parseInt(ele.STT)
          this.checkOrder = ele.STT + 1;
        }
      })
    }
    this.dataSource.push( {
      'userId': uuid.v4(),
      'enterpriseId': uuid.v4(),
      'customerId': uuid.v4(),
      'STT':this.checkOrder,
      'name':'',
      'phoneNumber':'',
      'email':'',
      'taxCode':'',
      'CTS':false,
      'image':false,
      'checkMail':false,
      'checkTrung':false,
      'checkFocusSTT':false,
      'checkFocusName':false,
      'checkFocusMail':false,
      'checkFocusPhone':false,
      'checkFocusCertificate':false,
      'validateForm':false,
      'checkPhone':false,
      'checkCertificate':false,
    });
  }
  onNoClick() {
    this.createContractService.procedureId = null;
    const dataOld = JSON.parse(localStorage.getItem('dataPopupCreateDocument'));
    this.dialogRef.close(dataOld);
  }

  onclickDelete(id){
this.dataSource = this.dataSource.filter(ele => {return ele.userId != id});
    this.dataSource.forEach(x =>{
      if(!x.STT){
        x.STT = 1
      }
    })
    this.dataSource.sort(function (a,b) {
      return a.STT - b.STT
    });
    var sortList = [];
    var count = 1;
    for (var i = 0;i < this.dataSource.length;i++){
      if(i > 0 && this.dataSource[i].STT !== this.dataSource[i-1].STT){
        count++;
      }
      sortList.push(count)
      // sortList.push(Object.assign({},this.listOfDataUserSign[i]))
    }
    this.dataSource.forEach((ele ,index) =>{
      sortList.forEach((ala,j) =>{
        if(index == j){
          ele.STT = ala;
        }
      })
    })
  }

  changeCheckBox(i){
    if(!this.dataSource[i].CTS){
      this.dataSource[i].image = false;
    }
    else{
      this.dataSource[i].image = true;
    }
  }
  async confirm() {
    this.dataSource.forEach(ele =>{
      if( !this.regxPhone.test(ele.phoneNumber) || !ele.phoneNumber || !ele.name || !ele.email || !ele.taxCode || ele.checkMail || ele.checkTrung || ele.checkCertificate || ele.checkPhone){
        ele.validateForm = true;
      }
      else {
        ele.validateForm = false;
      }
    })
    const dataCheck = this.dataSource.find(ele => {return !this.regxPhone.test(ele.phoneNumber) || !ele.phoneNumber || !ele.name || !ele.email || !ele.taxCode || ele.checkMail || ele.checkTrung || ele.checkCertificate || ele.checkPhone});
    if(dataCheck){
      this.validateForm = true;
      this.toast.error(this.message.getMessage('validation.validate_add_user_approve'));
      return;
    }
    else {
      this.dataSource.forEach(x =>{
        if(!x.STT){
          x.STT = 1
        }
      })
      this.dataSource.sort(function (a,b) {
        return a.STT - b.STT
      });
      var sortList = [];
      var count = 1;
      for (var i = 0;i < this.dataSource.length;i++){
        if(i > 0 && this.dataSource[i].STT !== this.dataSource[i-1].STT){
          count++;
        }
        sortList.push(count)
        // sortList.push(Object.assign({},this.listOfDataUserSign[i]))
      }
      this.dataSource.forEach((ele ,index) =>{
        sortList.forEach((ala,j) =>{
          if(index == j){
            ele.STT = ala;
          }
        })
      })
      this.validateForm = false;
      this.dialogRef.close(this.dataSource);
    }
    // this.dataSource.forEach(ele =>{
    //   if(ele.name || ele.email || ele.cetificateNo){
    //     this.validateForm = true;
    //   }
    // })
    // this.dialogRef.close(this.dataSource);

  }
  clickInput(data,i){
    if(data == 'checkFocusSTT'){
      this.dataSource[i].checkFocusSTT = true;
    }
    else if (data == 'checkFocusName'){
      this.dataSource[i].checkFocusName = true;
    }
    else if (data == 'checkFocusMail'){
      this.dataSource[i].checkFocusMail = true;
    }
    else if (data == 'checkFocusPhone'){
      this.dataSource[i].checkFocusPhone = true;
    }
    else{
      this.dataSource[i].checkFocusCertificate = true;
    }
  }
  clickInput2(data,i,res?){
    if(data == 'checkFocusSTT'){
      this.dataSource[i].checkFocusSTT = false;
      if(this.dataSource[i].STT){
        this.dataSource[i].STT = parseInt(this.dataSource[i].STT);
      }
      if(this.dataSource[i].STT || this.dataSource[i].STT === 0){
        if(this.dataSource[i].STT > 999){
          this.dataSource[i].STT = 999;
        }
        if(this.dataSource[i].STT < 1){
          this.dataSource[i].STT = 1;
        }
      }
    }
    else if (data == 'checkFocusName'){
      this.dataSource[i].checkFocusName = false;
    }
    else if (data == 'checkFocusMail'){
      this.checkMail(res,i);
      this.dataSource[i].checkFocusMail = false;
    }
    else if (data == 'checkFocusPhone'){
      if (this.containsNonNumericChars(this.dataSource[i].phoneNumber)) {
        this.dataSource[i].checkPhone = true
      } else {
        this.dataSource[i].checkPhone = false
      }
      this.dataSource[i].checkFocusPhone = false;
    }
    else{
      if (this.containsCCCDChars(this.dataSource[i].taxCode)) {
        this.dataSource[i].checkCertificate = true
      } else {
        this.dataSource[i].checkCertificate = false
      }
      this.dataSource[i].checkFocusCertificate = false;
    }
  }
  checkMail(data,i){
    const patternEmail = /^[_A-Za-z0-9-+]+(.[_A-Za-z0-9-]+)*@[A-Za-z0-9-]+(.[A-Za-z0-9]+)*(.[A-Za-z]{2,})$/;
    if(patternEmail.test(data)){
      this.dataSource[i].checkMail = false;
      this.checkTrungMail(data,i)
    }
    else{
      this.dataSource[i].checkMail = true;
    }
  }
 checkTrungMailAll(arr) {
   let nameCount = {};
   let duplicates = [];

   // Đếm số lần xuất hiện của từng name
   for (let obj of arr) {
     let name = obj.email;
     if (nameCount[name]) {
       nameCount[name]++;
     } else {
       nameCount[name] = 1;
     }
   }
   // Lọc ra các name có số lần xuất hiện lớn hơn 1 (tức là bị trùng)
   for (let name in nameCount) {
     if (nameCount[name] > 1) {
       duplicates.push(name);
     }
   }

   return duplicates;
    }
  checkTrungMail(data,i){
    if(data){
      const mail = this.dataSource.filter(ele =>
        ele.email == this.dataSource[i].email
      )
      if(mail.length > 1){
          this.dataSource.forEach(ele =>{
            if(mail[0].email && ele.email === mail[0].email) {
              ele.checkTrung = true
            }})
        // this.dataSource[i].checkTrung = true;
      }
      else {
        this.dataSource[i].checkTrung = false;
      }
    };
    const mailAll = this.checkTrungMailAll(this.dataSource);
    if(mailAll.length >0){
      this.dataSource.forEach(ala =>{
        const check = mailAll.filter(ele =>{ return ala.email === ele }).length;
        if(check > 0){
          ala.checkTrung = true;
        }
        else {
          ala.checkTrung = false;
        }
      })
    }
    else {
      this.dataSource.forEach(ala =>{
          ala.checkTrung = false;
      })
    }

  }
  onlyNumbers(event: KeyboardEvent) {
    const charCode = (event.which) ? event.which : event.keyCode;
    if (charCode > 31 && (charCode < 48 || charCode > 57)) {
      event.preventDefault();
    }
  }
  onlyCCCDNumbers(event: KeyboardEvent) {
    const regex = /^[a-zA-Z0-9-/áàảãạÁÀẢÃẠấầẩẫậẤẦẨẪẬắằẳẵặẮẰẲẴẶéèẻẽẹÉÈẺẼẸếềểễệẾỀỂỄỆóòỏõọÓÒỎÕỌớờởỡợỚỜỞỠỢúùủũụÚÙỦŨỤứừửữựỨỪỬỮỰíìỉĩịÍÌỈĨỊýỳỷỹỵÝỲỶỸỴđĐ]*$/;
    const charCode = (event.which) ? event.which : event.keyCode;

    if (charCode > 31 && (charCode < 48 || charCode > 57) && charCode !== 45 && charCode !== 47) {
      if (!regex.test(event.key)) {
        event.preventDefault();
      }
    }
  }
  containsNonNumericChars(input: string): boolean {
    const nonNumericRegex = /[^0-9]/;
    return nonNumericRegex.test(input);
  }
  containsCCCDChars(input: string): boolean {
    const nonNumericRegex = /^[a-zA-Z0-9-/áàảãạÁÀẢÃẠấầẩẫậẤẦẨẪẬắằẳẵặẮẰẲẴẶéèẻẽẹÉÈẺẼẸếềểễệẾỀỂỄỆóòỏõọÓÒỎÕỌớờởỡợỚỜỞỠỢúùủũụÚÙỦŨỤứừửữựỨỪỬỮỰíìỉĩịÍÌỈĨỊýỳỷỹỵÝỲỶỸỴđĐ]*$/;
    return !nonNumericRegex.test(input);
  }

  protected readonly SCREEN_SIZE = SCREEN_SIZE;
  protected readonly enumContractStatus = EnumContractStatus;
  protected readonly onchange = onchange;
}
